<template>
  <SpFinder
    ref="finder"
    :url="{
      data: 'https://ecboot.it.shopex123.com/finder/data/list?finderId=1'
    }"
    title="数据"
    :columns="columns"
    :actions="actions"
  />
</template>

<script>
export default {
  data () {
    const columns = [
      {
        name: '字段名', // 表头
        key: 'columnNameLabel' // 匹配data key
      },
      {
        name: '展示宽度',
        key: 'columnWidth',
        formatter: (row, col, val) => `${val}px` // 参照 https://element.eleme.io/#/zh-CN/component/table Table-column Attributes formatter
      },
      {
        name: '头部位置渲染',
        block: 'header', // 展示位置，header | footer
        width: 200,
        render: (h, { row }) => {
          // jsx语法支持单元格渲染
          return (
            <div>
              <el-popover trigger='click' placement='right'>
                <span>{`${row.columnName}: ${row.columnNameLabel}`}</span>
                <el-tag slot='reference' nativeOnClick={(e) => this.handleTagClick(e, row)}>
                  {row.columnNameLabel}
                </el-tag>
              </el-popover>
            </div>
          )
        }
      }
    ]

    const actions = [
      {
        name: '创建',
        key: 'create', // 用于指定key,必填
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        action: {
          type: 'link',
          path: '/connector'
        }
      },
      {
        name: '编辑',
        key: 'edit',
        type: 'button',
        action: {
          type: 'link',
          path: (row, selections) => `/connector?id=${row.schemaId}` // 方法方式跳转
        }
      },
      {
        name: '查看详情',
        key: 'detail',
        type: 'button',
        action: {
          type: 'link',
          path: '/connector?id=${schemaId}' // 字符串方式跳转
        }
      },
      {
        name: '删除',
        key: 'delete',
        type: 'button',
        action: {
          type: 'api',
          path: '/finder/schema/setting?finderId=${schemaId}', // api url
          // path: async (data) => await this.$http.post('/finder/schema/setting', data), // api 方法调用
          onSuccess: () => {
            this.$refs.finder.refresh()
          },
          confirm: {
            message: '请确认是否删除？',
            title: '提示'
          }
        }
      }
    ]

    return {
      columns,
      actions
    }
  },

  methods: {
    handleTagClick (e, row) {
      const popoverEl = e.target.parentNode.parentNode
      setTimeout(() => {
        popoverEl.__vue__.showPopper = false
      }, 1000)
      console.info(row)
    },

    async handleTransform (selection) {
      this.$message({
        message: `转移${selection.length}条记录`,
        type: 'success',
        onClose: () => {
          this.$refs.finder.refresh()
        }
      })
    },

    async handleRemove (selection) {
      this.$message({
        message: `成功删除${selection.length}条记录`,
        type: 'success',
        onClose: () => {
          this.$refs.finder.refresh()
        }
      })
    },

    handleClickInsert () {
      this.$message.info('点击了按钮')
    }
  }
}
</script>
